define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseCollection = require("collections/BaseCollection");
    var ManageDomainsBoxItemModel = require("manager-models/ManageDomainsBoxItemModel");

    var ManageDomainsBoxCollection = {};
    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {

        ManageDomainsBoxCollection = BaseCollection.extend({
            model : ManageDomainsBoxItemModel,
            name: "ManageDomainsBoxCollection",

            validate : function () {
                var errors = {};

                _.each(this.models, function(model) {
                    var modelErrors = model.validate();
                    if (modelErrors) {
                        errors[model.get(ManageDomainsBoxItemModel.KEYS.URL)] = modelErrors;
                    }
                });

                // Trigger validated events.
                // Need to defer this so the model is actually updated before
                // the event is triggered.
                _.defer(_.bind(function() {
                    this.trigger('validated:' + (_.isEmpty(errors) ? 'valid' : 'invalid'), this, errors);
                }, this));

                return errors;
            },

            addItem:function (options) {
                this.add(new ManageDomainsBoxItemModel(options));
            },

            isEmpty: function() {
                var isEmpty = true;
                _.find(this.models, function (model) {
                    if(!_.isEmpty(model.get(ManageDomainsBoxItemModel.KEYS.URL))) {
                        isEmpty = false;
                        return true;
                    }
                }, this);
                return isEmpty;
            }
        });

    });
    return ManageDomainsBoxCollection;
});
